import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import TUIRoomCore from '../../tui-room-core';
import SvgIcon from '../common/SvgIcon.vue';
import { useRoomStore } from '../../../stores/room';
import { useBasicStore } from '../../../stores/basic';
import { ICON_NAME } from '../../../constants/icon';
import MemberItem from './MemberItem/index.vue';
import { ref } from 'vue-demi';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const basicStore = useBasicStore();
const roomStore = useRoomStore();

const { userList, userNumber, applyToAnchorList } = storeToRefs(roomStore);


const arrList=ref([])
const arr=ref([])
const arrs=ref([])
 function getArr(){
  for(let i of userList.value){
    let msg=i.userName.substring(3).slice(0,2)
    if(msg=='主持'){
      arr.value.push(i)
    }else if(msg=='老师'){
      arr.value.push(i)
    }
    else{
      arrs.value.push(i)
    }

  }
}
 getArr()
function showApplyUserLit() {
  basicStore.setShowApplyUserList(true);
}

async function toggleAllAudio() {
  const newIsMuteAllAudio = !basicStore.isMuteAllAudio;
  basicStore.setIsMuteAllAudio(newIsMuteAllAudio);
  roomStore.setMuteAllAudio(newIsMuteAllAudio);
  await TUIRoomCore.muteAllUsersMicrophone(newIsMuteAllAudio);
}

async function toggleAllVideo() {
  const newIsMuteAllVideo = !basicStore.isMuteAllVideo;
  basicStore.setIsMuteAllVideo(newIsMuteAllVideo);
  roomStore.setMuteAllVideo(newIsMuteAllVideo);
  await TUIRoomCore.muteAllUsersCamera(newIsMuteAllVideo);
}

return { __sfc: true,basicStore, roomStore, userList, userNumber, applyToAnchorList, arrList, arr, arrs, getArr, showApplyUserLit, toggleAllAudio, toggleAllVideo, SvgIcon, ICON_NAME, MemberItem }
}

})